"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _Text = _interopRequireDefault(require("../../../../components/Text"));
var _theme = require("../../../../theme");
var _system = require("@mui/system");
var _i18n = _interopRequireDefault(require("../../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../../localization/tokens"));
var localizationMaps = _interopRequireWildcard(require("../../../../localization/maps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StyledContainer = (0, _system.styled)('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.15)',
    background: '#FFF',
    width: '254px',
    // 336,
    height: '240px',
    // 315,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    margin: '8px',
    position: 'relative',
    '&:hover': {
      boxShadow: '0px 12px 40px rgba(0, 0, 0, 0.15)'
    }
  };
});

/**
 * @param number
 * @returns {string}
 * @private
 */
var _formatNumber = function _formatNumber(number) {
  return "$".concat((number || 0).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
};

/**
 * 
 */
var setDescription = function setDescription(isCurrentAllocation, isFirstInvoice, date) {
  if (isCurrentAllocation) {
    return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      mediumLarge: true,
      display: "block",
      align: "center",
      marginBottom: 20
    }, _i18n["default"].t(_tokens["default"].labels.invoices.currentAllocation));
  }
  if (isFirstInvoice) {
    return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      mediumLarge: true,
      display: "block",
      align: "center",
      marginBottom: 20
    }, _i18n["default"].t(_tokens["default"].labels.invoices.censusBilling));
  }
  return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    display: "block",
    align: "center",
    marginBottom: 20
  }, dates.getLocalDisplay(date, 'MMMM YYYY', _i18n["default"].locale));
};

/**
 * @param total
 * @param date
 * @param status
 * @param onClick
 * @param classes
 * @param id
 * @param testid
 * @param isFirstInvoice
 * @returns {*}
 * @constructor
 */
var InvoiceTile = function InvoiceTile(_ref2) {
  var total = _ref2.total,
    date = _ref2.date,
    status = _ref2.status,
    onClick = _ref2.onClick,
    id = _ref2.id,
    testid = _ref2.testid,
    _ref2$isFirstInvoice = _ref2.isFirstInvoice,
    isFirstInvoice = _ref2$isFirstInvoice === void 0 ? false : _ref2$isFirstInvoice,
    _ref2$isCurrentAlloca = _ref2.isCurrentAllocation,
    isCurrentAllocation = _ref2$isCurrentAlloca === void 0 ? false : _ref2$isCurrentAlloca,
    _ref2$whitelabel = _ref2.whitelabel,
    whitelabel = _ref2$whitelabel === void 0 ? {} : _ref2$whitelabel;
  return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
    id: id || testid,
    onClick: onClick
  }, setDescription(isCurrentAllocation, isFirstInvoice, date) // get the date the bill was created (minus 1 month) to get the actual month the bill was for
  , isCurrentAllocation ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    tiny: true,
    display: "block",
    align: "center",
    margin: "10px 20px 15px"
  }, _i18n["default"].t(_tokens["default"].labels.invoices.nextChargePhrase)) : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    extraLarge: true,
    bold: true,
    display: "block",
    align: "center"
  }, _formatNumber(total)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    medium: true,
    color: status === 'Paid' ? _theme.colors.brandGreen : status === 'Failed' ? _theme.colors.red : whitelabel.primaryColor || _theme.colors.darkBlue,
    display: "block",
    align: "center",
    uppercase: true,
    bold: true
  }, status === 'Pending' ? localizationMaps.fromEnglish("invoiceStatuses", status) : ''));
};
var _default = exports["default"] = InvoiceTile;